import { render, staticRenderFns } from "./appupdate.vue?vue&type=template&id=1990095c"
import script from "./appupdate.vue?vue&type=script&lang=js"
export * from "./appupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports